// Copyright (c) 2016 Deere & Company

import PipClaim from '@deere/cps-it.warranty-model-factory/lib/claim-pip';

export const getUpdatedPipClaim = (currentClaim, selectedAction) =>
    PipClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/pip/services/update-pip-claim.js